module.exports = __webpack_public_path__ + "img/hero_floating.5e4f85c9.png";